import { registerBlockType } from "@wordpress/blocks";
import { __ } from "@wordpress/i18n";

registerBlockType("hoster/license-block", {
  title: __("User Licenses", "hoster"),
  icon: "admin-network",
  category: "widgets",
  edit: () => {
    return (
      <p>{__("User licenses will be displayed on the frontend.", "hoster")}</p>
    );
  },
  save: () => null, // Uses PHP render_callback
});
